import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=06451489&scoped=true"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"
import style0 from "./CreateTask.vue?vue&type=style&index=0&id=06451489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06451489",
  null
  
)

export default component.exports